<!-- removeItemModal -->
<ng-template #deletemodal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <div class="mt-2 text-center">
          <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
          <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>{{'heading-title.are-you-sure' | translate}}</h4>
          </div>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button id="delete-details" class="btn w-sm btn-danger btn-load d-flex align-items-center justify-content-center" (click)="deleteData()" style="overflow: unset;" [ngClass]="{'pointer-events-none':helper.showBtnLoader[1]}">
            <span class="d-flex align-items-center">
                @if (helper.showBtnLoader[1]) {
                    <span class="spinner-border flex-shrink-0" role="status">
                        <span class="visually-hidden"></span>
                    </span>
                } @else {
                    <span class="flex-grow-1" [ngClass]="{'ms-2':helper.showBtnLoader[1]}">
                        {{'button-title.yes-delete-it' | translate}}
                    </span>
                }
            </span>
        </button>
        </div>
      </div>
    </div><!-- /.modal-content -->
  </ng-template>